import React from 'react'
import ComprehensiveResponsesContext from '../../../contexts/ComprehensiveResponsesContext'
import { TopicsDisplay } from "./TopicsDisplay"
import { TopicsDisplayHeader } from "./TopicsDisplayHeader"
import StatusContext from '../../../contexts/StatusContext';
import NavBarComprehensiveResponses from '../navbarcomprehensiveresponses/NavBarComprehensiveResponses';
import { PromptWithIcon } from '../promptwithicon/PromptWithIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'
import { PushButton } from '../pushbutton/PushButton'
import { AvailableCredits } from '../availablecredits/AvailableCredits'

import "./comprehensiveresponses.css"
import { WaitonResponse } from '../waitonresponse/WaitonResponse';

import { DialogProgress } from './DialogProgress';
import AIButton from '../aibutton/AIButton';
import Stack from '@mui/material/Stack'
import { DialogSelectModels } from '../aibutton/DialogSelectModels';



export const ComprehensiveResponses = () => {

  const alertYes = () => {
    onClearChat()
    closeDialogBox()
  }

  const alertCancel = () => {
    closeDialogBox()
  }

   const alertYesNewPrompt = () => {
    setOpenDialogNewPrompt(false)
    
    onSubmitChat()
  }

  const alertCancelNewPrompt = () => {
    setOpenDialogNewPrompt(false)
  }

  const closeDialogNewPrompt = () => {
     setOpenDialogNewPrompt(false)
  }

  let {
    promptsandresponses,
    confirmDelete,
    onDeletePrompt,
    changeConfirmDelete,
    onClearChat,
    
    chatPrompt,
    setChatPrompt,
    onSubmitChatNew,
    onSubmitChat,
    status,
    openDialogNewPrompt, 
    setOpenDialogNewPrompt,

  } = React.useContext(ComprehensiveResponsesContext);

  let {
    isMobile,
    scrollRef,
    changeLanguage,
    openDialog,
    openDialogBox,
    closeDialogBox,
    onCopy,
    focusRef,

    getAIModel,
    getAIProvider,

    onClickAIButton,
  } = React.useContext(StatusContext);



  return (

    <div className="homeContainer">
       
         {
            isMobile() &&
            <AIButton pane={0} provider = {getAIProvider()} model = {getAIModel()} onClick = {()=>{onClickAIButton(0)}}/>
          }
       
    
          <NavBarComprehensiveResponses title={changeLanguage('comprehensiveresponses', 'navbartitle')} />
       
          <div className="response-markdown" ref={scrollRef}>
  {
    Array.isArray(promptsandresponses) &&
    promptsandresponses.map((item, index) => (
      <div key={index}>
        <TopicsDisplayHeader 
          key={item.id}
          displayprompt={item} 
          displayicons={confirmDelete[promptsandresponses.indexOf(item)].state}
          changeConfirmDelete={changeConfirmDelete} 
          onDeletePrompt={onDeletePrompt} 
          onCopy={onCopy}
        />
        
        { 
          Array.isArray(item.response) && 
          item.response.map((item1, index1) => (
            <TopicsDisplay 
              key={index1} 
              index={index}
              topic={item.prompt}
              displayprompt={item1} 
              onCopy={onCopy}
            />
          )) 
        }
      </div>
    ))
  }
</div>
      {
        (!status) &&
          <WaitonResponse />
      }
        <hr className = 'separator'></hr>
        
        <PromptWithIcon prompt={chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmitChatNew} clearPrompt={false} placeholdertext={changeLanguage('common', 'promptplaceholder')} />
        {/*<RadioButtonsTwo />*/}
    
        <div>
          {
            (status) && <label className='statusLabel'>{status}</label>
          }
        </div>
       
        
        <div ref = {focusRef} className="mainButtons">
        <Stack direction = "row" spacing={2}>
           {
              !isMobile() &&
                <AIButton pane={0} provider = {getAIProvider()} model = {getAIModel()} onClick = {()=>{onClickAIButton(0)}}/>
              
          }

          <PushButton onClick={openDialogBox} label={changeLanguage('common', 'clearall')} />
          
        </Stack>
        <AvailableCredits />
        </div>
        <label style={{ width: isMobile() ? '100%' : '50%' }}>{changeLanguage("comprehensiveresponses", "note")}</label>
        
        <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog={openDialog} closeDialog={closeDialogBox} prompt={changeLanguage('dialog', 'cleardata')} />
        <AlertDialog alertYes={alertYesNewPrompt} alertCancel={alertCancelNewPrompt} openDialog={openDialogNewPrompt} closeDialog={closeDialogNewPrompt} prompt={changeLanguage('comprehensiveresponses', 'cleardata')} />
        {/*<DialogProgress />*/}
        <DialogProgress />
        <DialogSelectModels />
     
    </div>

  )
}


